import { useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";

const PostcodesTable = ({ data, isLoading = false, onSortChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Id", direction: "asc" });
  const { getResizeProps } = useColumnResize();

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig); // Notify parent about the sort change
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const items = Array.isArray(data) ? data : [];

  return (
    <div>
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th onClick={() => requestSort("terminalDr")} {...getResizeProps()}>
              Terminal DR {getSortArrow("terminalDr")}
            </th>
            <th onClick={() => requestSort("terminalEx")} {...getResizeProps()}>
              Terminal EX {getSortArrow("terminalEx")}
            </th>
            <th onClick={() => requestSort("postcode")} {...getResizeProps()}>
              Kod pocztowy {getSortArrow("postcode")}
            </th>
            <th onClick={() => requestSort("countId")} {...getResizeProps()}>
              Ilość punktów {getSortArrow("countId")}
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="4" className="text-center py-4">
                <Spinner animation="border" role="status" size="sm" className="me-2" />
                <span>Ładowanie danych...</span>
              </td>
            </tr>
          ) : items.length > 0 ? (
            items.map((item, index) => (
              <tr key={index}>
                <td>{item.terminalDr}</td>
                <td>{item.terminalEx}</td>
                <td>{item.postcode}</td>
                <td>{item.countId}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="13" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};
export default PostcodesTable;
